import React from 'react';
import {FlatList} from 'react-native';

export default function DraggableFlatList({renderItem, onDragEnd, ...props}) {
  return (
    <FlatList
      {...props}
      renderItem={info => renderItem({...info, drag: () => undefined, isActive: false})}
    />
  );
}
